import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import { Result, Button, Spin } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';

export default function PaymentStatusPage() {
  const [searchParams] = useSearchParams();
  const resultParam = searchParams.get("result");
  const paymentRef = searchParams.get("payment_ref");

  const [status, setStatus] = useState(resultParam || null); // "success", "fail", or null
  const [loading, setLoading] = useState(!resultParam && !!paymentRef);

  useEffect(() => {
    if (!resultParam && paymentRef) {
      fetch(`/api/konnect/check?payment_ref=${paymentRef}`)
        .then(res => res.json())
        .then(data => {
          setStatus(data.status === "success" ? "success" : "fail");
        })
        .catch(() => setStatus("fail"))
        .finally(() => setLoading(false));
    }
  }, [paymentRef, resultParam]);

  if (loading) {
    return (
      <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin tip="Vérification du paiement..." size="large" />
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#001529', minHeight: '100vh', padding: 40, color: 'white' }}>
    <div style={{ padding: "40px 20px", maxWidth: 600, margin: "0 auto", textAlign: "center" }}>
      <img
        src="/logo.PNG" // ⬅️ Make sure to place your logo in /public/logo.png or update path accordingly
        alt="Logo"
        style={{ maxWidth: 120, marginBottom: 30 }}
      />

      {status === "success" ? (
       <Result
  icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
  status="success"
  title={<span style={{ color: "white" }}>✅ Paiement réussi</span>}
  subTitle={<span style={{ color: "white" }}>Merci pour votre paiement. Il a été confirmé avec succès.</span>}
  extra={<Button type="primary" href="/">Retour à l’accueil</Button>}
/>

      ) : (
        <Result
  icon={<CloseCircleOutlined style={{ color: "#ff4d4f" }} />}
  status="error"
  title={<span style={{ color: "white" }}>❌ Paiement échoué</span>}
  subTitle={<span style={{ color: "white" }}>Le paiement a échoué ou a été annulé. Veuillez réessayer.</span>}
  extra={<Button type="primary" href="/">Retour à l’accueil</Button>}
/>

      )}
    </div>
    </div>
  );
}
